import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e81038b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "measures-container"
}
const _hoisted_2 = { class: "d-flex justify-content-between mb-24" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = { class: "measurement-view" }
const _hoisted_6 = {
  key: 1,
  class: "container bg-white rounded-1 p-16"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_multiple_button_select = _resolveComponent("v-multiple-button-select")!
  const _component_the_measures_table_view = _resolveComponent("the-measures-table-view")!
  const _component_the_measures_chart_view = _resolveComponent("the-measures-chart-view")!
  const _component_the_professional_expedient_forms_create_modal = _resolveComponent("the-professional-expedient-forms-create-modal")!
  const _component_the_professional_nutritional_anamnesis = _resolveComponent("the-professional-nutritional-anamnesis")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!!_ctx.currentExpedient.rgpdConfirmedAt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_multiple_button_select, { "div-class": "mb-16" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_button, {
                  variant: "multiple-pills",
                  class: _normalizeClass(["rounded-pill", {'active': _ctx.view === 'table'}]),
                  "aria-label": _ctx.$t('Tabla'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.view = 'table'))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Tabla')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "class"]),
                _hoisted_3,
                _createVNode(_component_v_button, {
                  variant: "multiple-pills",
                  class: _normalizeClass(["rounded-pill", {'active': _ctx.view === 'graph'}]),
                  "aria-label": _ctx.$t('Gráfica'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.view = 'graph'))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Gráfica')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "class"])
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              (_ctx.can('professional.expedient.form.store'))
                ? (_openBlock(), _createBlock(_component_v_button, {
                    key: 0,
                    variant: "secondary",
                    class: "me-16",
                    "aria-label": _ctx.$t('Añadir nueva medida'),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalToShow = 'the-professional-expedient-forms-create-modal'))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Añadir medida')), 1)
                    ]),
                    _: 1
                  }, 8, ["aria-label"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.view === 'table')
              ? (_openBlock(), _createBlock(_component_the_measures_table_view, {
                  key: 0,
                  "form-name": "medidas",
                  measures: _ctx.ascendentlyOrderedMeasures,
                  onLoadExpedientFormsRequested: _ctx.loadExpedientMeasures,
                  onShowFormCreateModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalToShow = 'the-professional-expedient-forms-create-modal'))
                }, null, 8, ["measures", "onLoadExpedientFormsRequested"]))
              : (_openBlock(), _createBlock(_component_the_measures_chart_view, {
                  key: 1,
                  measures: _ctx.descendentlyOrderedMeasures,
                  "expedient-id": _ctx.currentExpedient.id,
                  onLoadExpedientMeasures: _ctx.loadExpedientMeasures,
                  onShowFormCreateModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalToShow = 'the-professional-expedient-forms-create-modal'))
                }, null, 8, ["measures", "expedient-id", "onLoadExpedientMeasures"]))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('Politicas RGPD no aceptadas en el expediente')), 1)),
    (_ctx.modalToShow === 'the-professional-expedient-forms-create-modal')
      ? (_openBlock(), _createBlock(_component_the_professional_expedient_forms_create_modal, {
          key: 2,
          "form-name": "medidas",
          "form-structure": _ctx.lastFormStructure,
          "treatment-id": _ctx.$route.query.tratamiento,
          onClosed: _cache[5] || (_cache[5] = ($event: any) => {_ctx.modalToShow = null;}),
          onCreateFormRequested: _ctx.createExpedientMeasure
        }, null, 8, ["form-structure", "treatment-id", "onCreateFormRequested"]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-professional-nutritional-anamnesis')
      ? (_openBlock(), _createBlock(_component_the_professional_nutritional_anamnesis, {
          key: 3,
          onClosed: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modalToShow = null))
        }))
      : _createCommentVNode("", true)
  ], 64))
}